import React, { useState, useEffect, useRef } from 'react';
import { Label, Modal } from '../styled-primitives';
import { FjFlexContainer, FjTooltip, FjInput, fjModalSizes, FjCheckbox } from '../primitives';
import { validateAuthorizedDeviceFingerprint } from '../../utils/validators';

type props = {
  acceptCallback: (
    fingerprint: string,
    deviceName: string,
    createEot: boolean,
    exportEot: boolean,
  ) => void;
  cancelCallback: () => void;
  allowEotCreation: boolean;
  isLoading: boolean;
};

export const CreateDeviceModal: React.FC<props> = ({
  acceptCallback,
  cancelCallback,
  allowEotCreation,
  isLoading,
}: props) => {
  const [fingerprint, setFingerprint] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [createEot, setCreateEot] = useState(false);
  const [exportEot, setExportEot] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    setIsValid(validateAuthorizedDeviceFingerprint.validator(fingerprint));
  }, [fingerprint]);

  const handleAccept = () => {
    if (deviceName === '') setDeviceName(fingerprint);
    acceptCallback(fingerprint, deviceName, createEot, exportEot);
  };

  return (
    <Modal
      data-testid="add-device-modal"
      cancel={{
        text: 'Cancel',
        callback: cancelCallback,
      }}
      accept={{
        text: 'Add',
        disabled: isLoading || !isValid,
        callback: handleAccept,
      }}
      title="Device Details"
      size={fjModalSizes.XS}
      showX
      onClickX={cancelCallback}
    >
      <FjFlexContainer direction="column">
        <FjFlexContainer direction="row" style={{ marginBottom: '16px' }}>
          <span>
            To add a new device, please enter the fingerprint provided in BD Access Portal.
          </span>
        </FjFlexContainer>
        <FjFlexContainer direction="row" style={{ marginBottom: '16px' }}>
          <FjTooltip
            Component={
              <>
                <div>The device fingerprint is a unique identifier for the device.</div>
                <div>Retrieve it from BD Access Portal on the device itself.</div>
              </>
            }
          >
            <Label>Device Fingerprint</Label>
          </FjTooltip>
          <FjInput
            placeholder="Fingerprint"
            autoFocus
            value={fingerprint}
            onChange={(val: string) => setFingerprint(val)}
            validator={fingerprint ? validateAuthorizedDeviceFingerprint.validator : () => true}
            getValidationMessage={validateAuthorizedDeviceFingerprint.getValidationMessage}
          />
        </FjFlexContainer>
        <FjFlexContainer direction="row">
          <FjTooltip
            Component={
              <>
                <div>Anything that will help you uniquely identify the device.</div>
                <div>Fingerprint will be used if this is left blank</div>
              </>
            }
          >
            <Label>Device Name</Label>
          </FjTooltip>
          <FjInput
            placeholder={fingerprint || 'Device Name'}
            value={deviceName}
            onChange={(val: string) => setDeviceName(val)}
          />
        </FjFlexContainer>
        {/* <FjFlexContainer className={allowEotCreation ? 'visible' : 'hidden'} direction="row">
          <Label>Create Extended Offline Token</Label>
          <FjCheckbox
            data-testid="create-eot-checkbox"
            checked={createEot}
            onChange={() => setCreateEot(!createEot)}
          />
        </FjFlexContainer>

        <FjFlexContainer className={createEot ? 'visible' : 'hidden'} direction="row">
          <Label>Export Extended Offline Token</Label>
          <FjCheckbox
            data-testid="export-eot-checkbox"
            checked={exportEot}
            onChange={() => setExportEot(!exportEot)}
          />
        </FjFlexContainer> */}
      </FjFlexContainer>
    </Modal>
  );
};
